<template>
    <div class="float-left mr-2">
        <span class="text-primary">
            <i
                class="fa fa-download fa-lg icon-button"
                title="Download"
                @click.stop="download()"
            ></i>
        </span>
    </div>
</template>

<script>
import AnexoServicos from './AnexoServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        anexo: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        download() {
            this.$store.dispatch('addRequest')
            let anexoDto = {
                idContrato: this.contrato.idContrato,
                idInvestimentoPrevistoContrato: this.anexo.idInvestimentoPrevistoContrato,
                idDocumentoInvestimentoPrevistoContrato: this.anexo.idDocumentoInvestimentoPrevistoContrato
            }
            AnexoServicos.download(anexoDto).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.anexo.documento)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>